import { defineStore } from "pinia";

import { useDataStore } from "./data";

export const useGlobeStore = defineStore("globe", {
    state: () => ({
        showLocked: true,
        showLines: true,
        showMarkers: true,
        autoRotateEnabled: true,

        hoveredCountry: null,
        hoveredLocked: false,
        hoveredContinent: null,

        selectedCountry: null,
        selectedContinent: null,
        selectedLocked: false,

        searchOpen: false,
        searchQuery: "",

        shootingStars: [],

        easterEggsFound: [],
        easterEggModal: null,

        lightboxClip: null,
    }),

    getters: {
        searchResults: (state) => {
            const q = state.searchQuery.trim().toLowerCase();
            if (!q) return [];
            const dataStore = useDataStore();
            return dataStore.searchableCities
                .filter((c) => c.name.toLowerCase().includes(q))
                .slice(0, 8);
        },

        hasClipsPanel: (state) =>
            !!state.selectedCountry && !state.selectedLocked,
    },

    actions: {
        setHover(name, locked = false, continent = null) {
            this.hoveredCountry = name;
            this.hoveredLocked = locked;
            this.hoveredContinent = continent;
        },

        clearHover() {
            this.hoveredCountry = null;
            this.hoveredLocked = false;
            this.hoveredContinent = null;
        },

        selectCountry(name, locked, continent) {
            this.selectedCountry = name;
            this.selectedLocked = locked;
            this.selectedContinent = continent;
        },

        clearSelection() {
            this.selectedCountry = null;
            this.selectedLocked = false;
            this.selectedContinent = null;
        },

        openSearch() {
            this.searchOpen = true;
        },

        closeSearch() {
            this.searchOpen = false;
            this.searchQuery = "";
        },

        selectFromSearch(name, locked, continent) {
            this.selectCountry(name, locked, continent);
            this.closeSearch();
        },

        spawnStar() {
            const id = Date.now() + Math.random();
            this.shootingStars.push({
                id,
                top: Math.random() * 40,
                left: Math.random() * 80 + 10,
                angle: 25 + Math.random() * 20,
            });
            return id;
        },

        removeStar(id) {
            this.shootingStars = this.shootingStars.filter((s) => s.id !== id);
        },

        triggerEasterEgg(egg) {
            if (this.easterEggsFound.includes(egg.id)) return;
            this.easterEggsFound.push(egg.id);
            this.easterEggModal = egg;
        },

        closeEasterEggModal() {
            this.easterEggModal = null;
        },

        toggleLocked() {
            this.showLocked = !this.showLocked;
        },
        toggleLines() {
            this.showLines = !this.showLines;
        },
        toggleMarkers() {
            this.showMarkers = !this.showMarkers;
        },
        toggleAutoRotate() {
            this.autoRotateEnabled = !this.autoRotateEnabled;
        },
    },
});
